import Cookies from 'js-cookie';

// กำหนดค่าเริ่มต้นสำหรับ cookies
const isDevelopment = import.meta.env.DEV;

const COOKIE_OPTIONS = {
  secure: !isDevelopment, // ใช้ HTTPS เท่านั้นใน production
  sameSite: isDevelopment ? ('lax' as const) : ('strict' as const), // ผ่อนปรนใน development
  expires: 30, // หมดอายุใน 30 วัน
};

/**
 * เก็บข้อมูลใน cookie
 * @param key ชื่อ key
 * @param value ค่าที่ต้องการเก็บ
 * @param options ตัวเลือกเพิ่มเติม
 */
export const setCookie = (key: string, value: string, options = {}): void => {
  Cookies.set(key, value, { ...COOKIE_OPTIONS, ...options });
};

/**
 * ดึงข้อมูลจาก cookie
 * @param key ชื่อ key
 * @returns ค่าที่เก็บไว้ หรือ null ถ้าไม่มี
 */
export const getCookie = (key: string): string | undefined => Cookies.get(key);

/**
 * ลบข้อมูลจาก cookie
 * @param key ชื่อ key
 */
export const removeCookie = (key: string): void => {
  Cookies.remove(key, COOKIE_OPTIONS);
};

/**
 * เก็บ token ใน cookie
 * @param token token ที่ต้องการเก็บ
 */
export const setAuthToken = (token: string): void => {
  setCookie('auth_token', token);
};

/**
 * ดึง token จาก cookie
 * @returns token หรือ undefined ถ้าไม่มี
 */
export const getAuthToken = (): string | undefined => getCookie('auth_token');

/**
 * ลบ token จาก cookie
 */
export const removeAuthToken = (): void => {
  removeCookie('auth_token');
};

/**
 * เก็บ refresh token ใน cookie
 * @param token refresh token ที่ต้องการเก็บ
 */
export const setRefreshToken = (token: string): void => {
  setCookie('refresh_token', token);
};

/**
 * ดึง refresh token จาก cookie
 * @returns refresh token หรือ undefined ถ้าไม่มี
 */
export const getRefreshToken = (): string | undefined => getCookie('refresh_token');

/**
 * ลบ refresh token จาก cookie
 */
export const removeRefreshToken = (): void => {
  removeCookie('refresh_token');
};
